import { LanguageService } from "../i18n/language.service";
import { MfeFramework } from "si-mfes-library/framework/mfe-framework";
import { UserStatusChangeEvent } from "si-mfes-library/users/user-status-change-event.model";
import { ILocalizationService } from "sirius-platform-support-library/shared/localization/localization-service.interface";
import DOMPurify from "dompurify";
import { ObjectUtility } from "sirius-platform-support-library/utilities/object-utility";

export class CommonElements {
  public static readonly NAVBAR_CUSTOM_ELEMENT_NAME = "tdp-navbar-mfe";

  private readonly window: Window;
  private readonly languageService: LanguageService;
  private readonly framework: MfeFramework;
  private readonly localizationService: ILocalizationService;

  private navbar?: Element;

  public constructor(
    window: Window,
    languageService: LanguageService,
    framework: MfeFramework,
    localizationService: ILocalizationService
  ) {
    this.window = window;
    this.languageService = languageService;
    this.framework = framework;
    this.localizationService = localizationService;
    this.localizationService.onLocaleChanged(
      this,
      "CommonElements",
      this.onLocaleChanged.bind(this)
    );
  }

  public async bootstrap(): Promise<void> {
    const locale = this.languageService.getLocale();
    await this.bootstrapHeader(locale);
  }

  public onLocaleChanged(locale: any): void {
    if (!locale?.currentLocaleCode) {
      return;
    }
    this.navbar?.setAttributeNS(
      null,
      "languagecode",
      locale?.currentLocaleCode
    );
  }

  private async bootstrapHeader(locale: string): Promise<void> {
    if (this.navbar) {
      return;
    }

    this.navbar = this.window.document.querySelector(
      CommonElements.NAVBAR_CUSTOM_ELEMENT_NAME
    );

    if (!this.navbar) {
      return;
    }

    this.navbar.setAttributeNS(null, "languagecode", locale);

    this.navbar.addEventListener("navigate", (event: CustomEvent) => {
      const newEvent = this.replaceLangUrl(
        event,
        this.localizationService.getCurrentLocaleCode()
      );
      this.framework.LinkNavigator.triggerNavigation(newEvent);
    });

    this.navbar.addEventListener("translateChange", (event: CustomEvent) => {
      const eventLocale = { currentLocaleCode: event.detail?.languageCode };
      this.languageService.onLocaleChanged(eventLocale);
    });

    this.navbar.addEventListener(
      "userStatusChange",
      (event: CustomEvent<UserStatusChangeEvent>) => {
        this.framework.CurrentUser.triggerCurrentUserChanged(event.detail);
      }
    );
  }

  public replaceLangUrl(event: CustomEvent, newLang: string): CustomEvent {
    if (!ObjectUtility.isDefined(event?.detail?.href)) {
      return;
    }
    const sanitizedUrl = DOMPurify.sanitize(event.detail.href);
    const parsedUrl = new URL(sanitizedUrl);
    const params = new URLSearchParams(parsedUrl.search);
    params.set("lang", newLang);
    const newUrl = `${parsedUrl.origin}${
      parsedUrl.pathname
    }?${params.toString()}`;
    event.detail.href = newUrl;
    return event;
  }
}
